import React from 'react';
import AdminPanelCcmNextAppointmentForm from 'components/molecules/admin-panel/forms/ccm-next-appointment';

import type { ModuleType } from 'infrastructure/enums';

interface IAdminTabbedFormCcmNextAppointmentProps {
  patientGuid: string;
  module: ModuleType;
  readOnly?: boolean;
}

const AdminTabbedFormCcmNextAppointment: React.FC<
  IAdminTabbedFormCcmNextAppointmentProps
> = (props) => {
  const { patientGuid, module, readOnly } = props;

  return (
    <div>
      <AdminPanelCcmNextAppointmentForm
        patientGuid={patientGuid}
        module={module}
        readOnly={readOnly}
      />
    </div>
  );
};

export default AdminTabbedFormCcmNextAppointment;
